import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { FiShield, FiToggleLeft, FiToggleRight, FiUser, FiLock, FiChevronRight } from 'react-icons/fi';
import Header from './Header';
import '../styles/SecurityPage.css';

const SecurityPage = () => {
  const navigate = useNavigate();
  const [biometricEnabled, setBiometricEnabled] = useState(false);
  const [autoLockEnabled, setAutoLockEnabled] = useState(true);
  const [askPasswordEnabled, setAskPasswordEnabled] = useState(true);

  const securityOptions = [
    {
      icon: FiUser,
      title: 'Biometric Authentication',
      description: 'Use fingerprint or face ID to unlock wallet',
      enabled: biometricEnabled,
      onToggle: () => setBiometricEnabled(!biometricEnabled),
      isLink: false
    },
    {
      icon: FiLock,
      title: 'Change PIN',
      description: 'Update your 4-digit wallet PIN',
      isLink: true,
      onClick: () => navigate('/settings/change-pin')
    },
    {
      icon: FiShield,
      title: 'Auto-Lock',
      description: 'Automatically lock wallet after 5 minutes',
      enabled: autoLockEnabled,
      onToggle: () => setAutoLockEnabled(!autoLockEnabled),
      isLink: false
    },
    {
      icon: FiShield,
      title: 'Ask Password for Transactions',
      description: 'Require PIN for sending assets',
      enabled: askPasswordEnabled,
      onToggle: () => setAskPasswordEnabled(!askPasswordEnabled),
      isLink: false
    }
  ];

  return (
    <div className="security-page">
      <Header title="Security" className="sticky-header" />

      <div className="security-content">
        <motion.div
          className="security-card"
          initial={{ scale: 0.95, opacity: 0, y: 20 }}
          animate={{ scale: 1, opacity: 1, y: 0 }}
          transition={{ duration: 0.4, ease: "easeOut" }}
        >
          <div className="security-header">
            <motion.div
              className="header-icon"
              initial={{ scale: 0 }}
              animate={{ scale: 1 }}
              transition={{ delay: 0.2, type: "spring" }}
            >
              <FiShield />
            </motion.div>
            <h2>Security Settings</h2>
            <p>Customize your security preferences to keep your assets safe.</p>
          </div>

          <div className="security-options">
            {securityOptions.map((option, index) => {
              const Icon = option.icon;
              return (
                <motion.div
                  key={option.title}
                  className="security-item"
                  initial={{ opacity: 0, x: -10 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ delay: index * 0.1 }}
                  onClick={option.isLink ? option.onClick : option.onToggle}
                  whileHover={{ scale: 1.02 }}
                  whileTap={{ scale: 0.98 }}
                >
                  <div className="item-content">
                    <div className="item-icon">
                      <Icon />
                    </div>
                    <div className="item-text">
                      <span className="item-title">{option.title}</span>
                      <span className="item-description">{option.description}</span>
                    </div>
                  </div>
                  {option.isLink ? (
                    <FiChevronRight className="chevron-icon" />
                  ) : (
                    <button
                      className={`toggle-button ${option.enabled ? 'active' : ''}`}
                      onClick={(e) => {
                        e.stopPropagation();
                        option.onToggle();
                      }}
                    >
                      {option.enabled ? <FiToggleRight /> : <FiToggleLeft />}
                    </button>
                  )}
                </motion.div>
              );
            })}
          </div>

          <div className="security-info">
            <h3>Security Recommendations</h3>
            <ul className="tips-list">
              <li>Enable biometric authentication for quick and secure access</li>
              <li>Set a strong PIN that only you know</li>
              <li>Never share your recovery phrase with anyone</li>
              <li>Always double-check transaction details</li>
            </ul>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default SecurityPage; 